import questionnaireRouter from "./questionnaire";
import mechanismRouter from "./mechanism";
import systemRouter from "./system";
import mechanismUserRouter from "./mechanismUser";
import userRouter from "./user";
export { questionnaireRouter, mechanismRouter, userRouter, mechanismUserRouter, systemRouter };